<template>
    <div>
        <div @click="showReason"><slot name="default"></slot></div>
        <el-dialog
            class="dialog-container"
            :visible.sync="dialog"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :before-close="cancel"
            :title="title"
            append-to-body
            center>
            <div class="flex flex-direction padding">
                <el-form class="ruleForm" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="auto">
                    <el-form-item prop="reason">
                        <el-input v-model="ruleForm.reason" :autosize="{ minRows: 6, maxRows: 6 }" :placeholder="placeholder" resize="none"
                                  type="textarea">
                        </el-input>
                    </el-form-item>
                </el-form>
                <div class="dialog-operate flex align-center justify-center">
                    <el-button class="btn min round" type="info" @click="cancel">{{cancelText}}</el-button>
                    <el-button class="btn min round" type="primary" :loading="loading" @click="submitForm('ruleForm')">
                        {{confirmText}}
                    </el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>

export default {
    name: "EditReason",
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: '拒绝原因'
        },
        cancelText: {
            type: String,
            default: '取消'
        },
        confirmText: {
            type: String,
            default: '确认'
        },
        placeholder: {
            type: String,
            default: '请输入'
        },
        params: {
            type: Object,
            default() {
                return {}
            }
        }
    },
    data() {
        return {
            dialog: false,
            ruleForm: {
                reason: ''
            },
            rules: {
                reason: [
                    {required: true, message: '请输入', trigger: 'blur'}
                ]
            },
        }
    },
    created() {
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitReason();
                }
            });
        },
        submitReason() {
            this.$emit('reason', {
                ...this.params,
                reason: this.ruleForm.reason,
                ref:this
            })
        },
        showReason() {
            this.dialog = true
            this.clearContent()
        },
        clearContent() {
            this.$refs.ruleForm && this.$refs.ruleForm.resetFields()
        },
        cancel() {
            this.clearContent()
            this.dialog = false
        }
    },
    watch: {

    }
}
</script>

<style scoped lang="scss">

</style>